<template>
  <div />
</template>

<script>
export default {
  name: "RwHeader"
};
</script>
